/**
 * Dev-only console logger. In production these are compiled out via NODE_ENV
 * checks and never leak to end users. Import + call `devWarn` in place of an
 * empty `catch { }` block so silent failures still surface during development
 * without polluting production consoles.
 */
export function devWarn(scope, err) {
  if (typeof process !== "undefined" && process.env && process.env.NODE_ENV === "production") {
    return;
  }
  // eslint-disable-next-line no-console
  console.debug(`[dev] ${scope}:`, err);
}
